import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import hash from 'object-hash';
import { cacheActionKey } from '../../../utils/cache/caching';

const FEATURE_KEY = 'cache';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface CacheState {
  actions: {
    [key: string]: number;
  };
}

const initialState: CacheState = {
  actions: {},
};

export const cacheSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setLastModified: (
      state,
      action: PayloadAction<{ actionName: string; payload: any }>
    ) => {
      const key = cacheActionKey(
        action.payload.actionName,
        action.payload.payload
      );
      state.actions[key] = new Date().getTime();
    },
    clearCache: (state, action: PayloadAction<string>) => {
      delete state.actions[action.payload];
    },
  },
});

/*
 * Export reducer for store configuration.
 */
export const cacheReducer = cacheSlice.reducer;
export const cacheActions = cacheSlice.actions;

const state = (rootState: any): CacheState => rootState[FEATURE_KEY];
